import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import css from './ProfileMenuContent.css';
import { MenuItem, NamedLink } from '../../..';
import classNames from 'classnames';
import { isCurrentPageLoggedOut } from '../../Topbar.helpers';
import { IconChevronRightStrongL } from '../../../../icons';
import DropdownHolder from '../LandingPageLoggedOutMenu/DropdownHolder';
import {
    ABOUT_US,
    FIND_HORSE,
    FIND_SUPPORT,
    RESOURCES,
    dropdownsConfig,
} from '../LandingPageLoggedOutMenu/dropdowns';

const ProfileMenuContentLoggedOut = ({ currentPage, isMobile }) => {
    const history = useHistory();

    const [dropdownId, setDropdownId] = useState(FIND_HORSE);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const openDropdownAsideMenu = id => {
        setDropdownId(id);
        setDropdownOpen(true);
    };

    const currentDropdownClass = id =>
        dropdownsConfig[id].isSelected(history) ? css.currentPageDropdown : null;

    const currentPageClass = page =>
        isCurrentPageLoggedOut(page, currentPage) ? css.currentPage : null;

    return (
        <>
            {isMobile && dropdownsConfig[dropdownId] && (
                <DropdownHolder
                    isMobile
                    isOpen={dropdownOpen}
                    rootClassName={css.dropdownItemsMobile}
                    onClose={() => setDropdownOpen(false)}
                    dropdownId={dropdownId}
                >
                    {dropdownsConfig[dropdownId].items}
                </DropdownHolder>
            )}
            {/* Login */}
            <MenuItem
                key="LoginPage"
                rootClassName={classNames(
                    css.topBarMenuItem,
                    css.topBarMenuItemFirst,
                    currentPageClass('LoginPage')
                )}
            >
                <NamedLink className={css.topBarMenuLink} name="LoginPage">
                    <p>Anmelden</p>
                </NamedLink>
            </MenuItem>
            {/** Sign up */}
            <MenuItem
                key="SignupPage"
                rootClassName={classNames(css.topBarMenuItem, currentPageClass('SignupPage'))}
            >
                <NamedLink className={css.topBarMenuLink} name="SignupPage">
                    <p>Mitglied werden</p>
                </NamedLink>
            </MenuItem>

            <div className={classNames(css.divider, css.desktopOnly)} />
            {/** Find horse or rider */}
            {isMobile && (
                <>
                    <MenuItem
                        key="FindListingsSubLabel"
                        rootClassName={classNames(css.topBarMenuItem, css.topBarMenuSubLabel)}
                    >
                        <p>Finden</p>
                    </MenuItem>

                    {/** Find horse */}
                    <MenuItem
                        key="FindHorsePage"
                        rootClassName={classNames(
                            css.topBarMenuItem,
                            currentDropdownClass(FIND_HORSE)
                        )}
                        onClick={() => openDropdownAsideMenu(FIND_HORSE)}
                    >
                        <p>{dropdownsConfig[FIND_HORSE].label}</p>
                        <IconChevronRightStrongL />
                    </MenuItem>
                    {/**  Find rider */}
                    <MenuItem
                        key="FindRiderPage"
                        rootClassName={classNames(
                            css.topBarMenuItem,
                            currentDropdownClass(FIND_SUPPORT)
                        )}
                        onClick={() => openDropdownAsideMenu(FIND_SUPPORT)}
                    >
                        <p>{dropdownsConfig[FIND_SUPPORT].label}</p>
                        <IconChevronRightStrongL />
                    </MenuItem>
                </>
            )}
            <MenuItem
                key="ContactAndAboutUsSubLabel"
                rootClassName={classNames(
                    css.topBarMenuItem,
                    css.topBarMenuSubLabel,
                    css.mobileOnly
                )}
            >
                <p>Unternehmen</p>
            </MenuItem>
            {isMobile && (
                <MenuItem
                    key="Ressourcen"
                    rootClassName={classNames(css.topBarMenuItem, currentDropdownClass(RESOURCES))}
                    onClick={() => openDropdownAsideMenu(RESOURCES)}
                >
                    <p>{dropdownsConfig[RESOURCES].label}</p>
                    <IconChevronRightStrongL />
                </MenuItem>
            )}
            {/** About us */}

            {isMobile ? (
                <MenuItem
                    key="AboutUs"
                    rootClassName={classNames(css.topBarMenuItem, currentDropdownClass(ABOUT_US))}
                    onClick={() => openDropdownAsideMenu(ABOUT_US)}
                >
                    <p>{dropdownsConfig[ABOUT_US].label}</p>
                    <IconChevronRightStrongL />
                </MenuItem>
            ) : (
                <MenuItem
                    key="AboutUs"
                    rootClassName={classNames(css.topBarMenuItem, currentPageClass('AboutUs'))}
                >
                    <NamedLink className={css.topBarMenuLink} name="AboutUs">
                        <p>Über uns</p>
                    </NamedLink>
                </MenuItem>
            )}

            {/** Contact us */}
            <MenuItem
                key="CareerPage"
                rootClassName={classNames(
                    css.topBarMenuItem,
                    css.topBarMenuItemLast,
                    currentPageClass('CareerPage')
                )}
            >
                <a className={css.topBarMenuLink} href="/karriere">
                    <p>Kontakt</p>
                </a>
            </MenuItem>
        </>
    );
};

export default ProfileMenuContentLoggedOut;
